import React from 'react'
import { StaticImage } from "gatsby-plugin-image"

import styles from './styles.module.styl'

import VK from '../../../assets/svg/icon_vk.svg'
import Facebook from '../../../assets/svg/icon_facebook.svg'
import Instagram from '../../../assets/svg/icon_instagram.svg'
import Youtube from '../../../assets/svg/icon_youtube.svg'
import Appstore from '../../../assets/svg/Group.svg'

import sectionData from '../../../pages-data/index/footer'

import SectionContainer from '../../SectionContainer'
import AdaptiveLink from '../../AdaptiveLink'


export default function SectionFooter() {

  const linkList = array => {
    return array.map(
      item =>
        <AdaptiveLink
          className={styles.footer__ref}
          href={item.href}
          key={item.text}
          useGatsbyLink={item.useGatsbyLink}
        >
          {item.text}
        </AdaptiveLink>
    )
}
  return (
  <SectionContainer className={styles.footer__container}>
    <section className={styles.footer}>


      <div className={styles.footer__column}>

        <div>
          <h4 className={styles.footer__columnListHeader}>
            {sectionData.firstColumn.header}
          </h4>
          <div className={styles.footer__columnList}>
            {linkList(sectionData.firstColumn.refs)}
          </div>
        </div>

        <span className={styles.footer__columnFooter}>
                    {sectionData.firstColumn.footer}
                </span>

      </div>


      <div className={styles.footer__column}>

        <div>
          <h4 className={styles.footer__columnListHeader}>
            {sectionData.secondColumn.header}
          </h4>
          <div className={styles.footer__columnList}>
            {linkList(sectionData.secondColumn.refs)}
          </div>
        </div>

        <AdaptiveLink
          className={`
                        ${styles.footer__columnFooter}
                        ${styles.__link}
                        `}
          href={sectionData.secondColumn.footer.href}
          useGatsbyLink={sectionData.secondColumn.footer.useGatsbyLink}
        >
          {sectionData.secondColumn.footer.text}
        </AdaptiveLink>
      </div>


      <div className={styles.footer__column}>
        <div>
          <h4 className={styles.footer__columnListHeader}>
            {sectionData.thirdColumn.header}
          </h4>
          <div className={styles.footer__columnList}>
            {linkList(sectionData.thirdColumn.refs)}
          </div>
        </div>
        <AdaptiveLink
          className={`
                        ${styles.footer__columnFooter}
                        ${styles.__link}
                    `}
          href={sectionData.thirdColumn.footer.href}
          useGatsbyLink={sectionData.thirdColumn.footer.useGatsbyLink}
        >
          {sectionData.thirdColumn.footer.text}
        </AdaptiveLink>
      </div>


      <div className={styles.footer__columnFourth}>

        <a
          href={`tel:${sectionData.phone.value}`}
          className={styles.footer__columnFourth__phoneNumber}
        >
          {sectionData.phone.title}
        </a>
        <a
          href={`mailto:${sectionData.email}`}
          className={styles.footer__columnFourth__email}
        >
          {sectionData.email}
        </a>


        <div className={styles.footer__columnFourth__social}>
          <a
            aria-label={sectionData.vk.ariaLabel}
            href={sectionData.vk.href}
            target='_blank'
          >
            <VK/>
          </a>
          {/*<a*/}
          {/*  aria-label={sectionData.facebook.ariaLabel}*/}
          {/*  href={sectionData.facebook.href}*/}
          {/*  target='_blank'*/}
          {/*>*/}
          {/*  <Facebook/>*/}
          {/*</a>*/}
          {/*<a*/}
          {/*  aria-label={sectionData.instagram.ariaLabel}*/}
          {/*  href={sectionData.instagram.href}*/}
          {/*  target='_blank'*/}
          {/*>*/}
          {/*  <Instagram/>*/}
          {/*</a>*/}
          <a
            aria-label={sectionData.youtube.ariaLabel}
            href={sectionData.youtube.href}
            target='_blank'
          >
            <Youtube/>
          </a>
        </div>


        <div className={styles.footer__columnFourth__copyrights}>
          {sectionData.firstColumn.footer}
        </div>


        <div className={styles.footer__columnFourth__researches}>
          {sectionData.researches}
        </div>


        <div className={styles.footer__columnFourth__patrons}>
          <a
            href={sectionData.oneC.link}
            target='_blank'
          >
            <StaticImage
              src='../../../assets/images/badge_1c.png'
              alt={sectionData.oneC.alt}
            />
          </a>
          <a
            className={styles.footer__skolkovoBadge}
            href={sectionData.skolkovo.link}
            target='_blank'
          >
            <StaticImage
              src='../../../assets/images/badge_skolkovo.png'
              alt={sectionData.skolkovo.alt}
            />
          </a>
        </div>


        <div className={styles.footer__columnFourth__stores}>
          <a
            aria-label={sectionData.appstore.ariaLabel}
            href={sectionData.appstore.href}
            target='_blank'
          >
            <Appstore/>
          </a>

          <a
            className={styles.footer__columnFourth__googleplay}
            href={sectionData.googleplay.link}
            target='_blank'
          >
            <StaticImage
              src='../../../assets/images/googleplay3x.png'
              alt={sectionData.googleplay.alt}
            />
          </a>
        </div>
      </div>

      <div className={styles.footer__divider}></div>

    </section>
  </SectionContainer>
  )
}
